(function () {
  "use strict";

  XlsCtrl.$inject = ['$scope', '$location', 'accountCustomFields', 'usersResource', 'xlsConsts', 'xlsValidator', 'xlsAutoMapper', '$modal', '$routeParams', 'mtypes', 'accountFeatures', 'modalHelper', 'actionLogResource', 'trainerPrivilege', 'hqTypes'];
  angular
    .module('trainerWebApp.controllers')
    .controller('XlsCtrl', XlsCtrl);

  function XlsCtrl($scope, $location, accountCustomFields, usersResource, xlsConsts, xlsValidator, xlsAutoMapper, $modal,
                   $routeParams, mtypes, accountFeatures, modalHelper, actionLogResource, trainerPrivilege, hqTypes) {

    var userRole = trainerPrivilege.roles();
    if (!userRole.canInviteUsers) {
      if ($routeParams.courseId)
        $location.path('/TMS/Distribute_Course/' + $routeParams.courseId + '/trainees');
      else if ($routeParams.seriesId)
        $location.path('/TMS/Series/' + $routeParams.seriesId + '/trainees');
      else
        $location.path('/TMS/ManageUsers');
    }

    var queryParams = $location.search();

    $scope.montara = queryParams.course;

    var xlsState;
    var screens = this.screens = {
      upload: 'Upload',
      confirm: 'Confirm',
      mapping: 'Mapping',
      error: 'Error'
    };
    var states = this.states = {
      start: 'start',
      uploaded: 'uploaded',
      importing: 'importing',
      complete: 'complete'
    };

    var setView = this.setView = function (step) {
      xlsState.step = step;
      xlsState.viewUri = 'pages/users/xls/xls' + step + '.html';
      $location.search('step', step);
    };

    var onRouteUpdate = this.onRouteUpdate = function (e, route) {
      var params = route.params;
      var lastKnownStep = xlsState.step;

      if (params.step === lastKnownStep) // normal flow
        return;

      if (params.step === screens.upload || xlsState.state !== states.uploaded)
        return reset();

      // resets state when the uploaded data has errors and navigates to a page that is not the errors screen or the mapping screen
      if (xlsState.generalErrors && !~[screens.error, screens.mapping].indexOf(params.step))
        return reset();

      setView(params.step);
    };

    var hqSyncWarning = false;

    $scope.$on("$routeUpdate", onRouteUpdate);

    $scope.xlsDataReady = function (data) {
      xlsState.columnNames = data.columnNames;
      xlsState.rows = data.rows;
      xlsState.rowOffset = data.rowOffset;

      _.each(data.rows, function (row, idx) {
        row.id = idx + data.rowOffset;
      });

      guessMapping();
      xlsState.state = states.uploaded;
      setView(screens.mapping);
    };

    var guessMapping = this.guessMapping = function () {
      var guessInfo = xlsAutoMapper.guessMapping(xlsState.columnNames, xlsState.userFields);
      xlsState.userFields = guessInfo.fields;
      xlsState.matchedFields = guessInfo.matched;
      xlsState.unmatchedFields = guessInfo.unmatched;
    };

    $scope.mappingApplied = function () {
      xlsValidator.setErroredRows({
        rows: xlsState.rows,
        fields: xlsState.userFields,
        rowOffset: xlsState.rowOffset
      });
      usersResource.getXlsUserImportSetup(applyAccountInfo);
    };

    $scope.pageLocation = getPageLocation();

    function getPageLocation() {
      var type = {};
      if ($routeParams.courseId) {
        type.id = 'course';
        type.url = "#/TMS/Distribute_Course/" + $routeParams.courseId + "/trainees";
      } else if ($routeParams.seriesId) {
        type.id = 'series';
        type.url = "#/TMS/Series/" + $routeParams.seriesId + "/trainees";
      } else {
        type.id = 'manage';
        type.url = '#/TMS/ManageUsers/';
      }
      return type;
    }

    $scope.remapFields = function () {
      setView(screens.mapping);
    };

    $scope.acceptErrors = function () {
      setView(screens.confirm);
    };

    var importDialog;
    $scope.doImport = function () {
      if (mfConfig.useGroupRestrictions && (!xlsState.selectedGroups || xlsState.selectedGroups.length == 0)) {
        modalHelper.messageBox({
          title: 'Trainees require group membership',
          message: 'You must add the trainee(s) to a group you manage'
        });
        return;
      }

      $('#xlsAddButtonHACK').attr('disabled', 'true');
      xlsState.state = states.importing;
      importDialog = $modal.open({
        keyboard: false,
        backdropClick: false,
        templateUrl: 'pages/users/xls/xlsImportDlg.html',
        controller: 'XlsImportDlgCtrl',
        resolve: {
          xlsState: function () {
            return xlsState;
          }
        }
      });
      importDialog.result.then(function (result) {
        if (result === 'done')
          reset();
      });

      xlsState.importIdx = 0;
      xlsState.importedUserCount = 0;
      var importObj = getImportObj();

      function importNextBatch(batchRes) {
        if (batchRes && batchRes.warnings && batchRes.warnings.length > 0) {
          hqSyncWarning = true;
        }
        if (xlsState.importIdx >= xlsState.rows.length || xlsState.state !== states.importing) {
          xlsState.state = states.complete;
          return;
        }

        var importBatchSize = 200;
        var users = importObj.users = [];
        for (; xlsState.importIdx < xlsState.rows.length && users.length < importBatchSize; xlsState.importIdx++) {
          var row = xlsState.rows[xlsState.importIdx];
          if (!row.$errors)
            users.push(mapRowToUser(row));
        }

        xlsState.importedUserCount += users.length;
        usersResource.importUsers(importObj, importNextBatch);
      }

      importNextBatch();
    };

    var getImportObj = this.getImportObj = function () {
      var date = new Date();
      var dateString = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      var courseIds = [];

      if ($routeParams.courseId) {
        // TODO: Not sure if this is wired up for a particular url but should keep for future
        courseIds = [parseInt($routeParams.courseId, 10)];
      } else if($routeParams.seriesId) {
        // add users from a course since the old routes are still wired up for series
        courseIds = [parseInt($routeParams.seriesId, 10)];
      } else {
        // add users from the users tab
        courseIds = _.map(xlsState.selectedCourseSeries, 'id');
      }

      return {
        users: [],
        groupRestrictionIds: [],
        requiredCourseIds: xlsState.courseSeriesRequired ? courseIds : [],
        courseIds: !xlsState.courseSeriesRequired ? courseIds : [],
        clientDatestamp: dateString,
        groupIds: _.map(xlsState.selectedGroups, 'id'),
        batchId: Date.now()
      };
    };

    var activeAccountEmails = {}, activeAccountUsernames = {};
    var usersNotAllowedToUpdateByEmail = {}, usersNotAllowedToUpdateByUsername = {};

    var applyAccountInfo = this.applyAccountInfo = function (info) {
      xlsState.existingUsersFound = false;
      xlsState.fatalError = false;

      // arrays to hashes for speed
      _.each(info.active, function (activeUser) {
        if (activeUser.email) {
          activeAccountEmails[activeUser.email.toLowerCase()] = 1;
          if (!activeUser.allowedInGroup)
            usersNotAllowedToUpdateByEmail[activeUser.email.toLowerCase()] = 1;
        }

        if (activeUser.username) {
          // we will keep permissions to check later if we can update that user
          activeAccountUsernames[activeUser.username.toLowerCase()] = activeUser.permissions;
          if (!activeUser.allowedInGroup)
            usersNotAllowedToUpdateByUsername[activeUser.username.toLowerCase()] = 1;
        }
      });

      var allUsers = [];
      if (info.active)
        allUsers = allUsers.concat(info.active);
      if (info.archived)
        allUsers = allUsers.concat(info.archived);
      _.each(allUsers, function (user) {
        if (!user.allowedInGroup) {
          if (user.email)
            usersNotAllowedToUpdateByEmail[user.email.toLowerCase()] = 1;

          if (user.username)
            usersNotAllowedToUpdateByUsername[user.username.toLowerCase()] = 1;
        }
      });

      var emailIdx = xlsState.emailColumnIdx;
      var usernameIdx = xlsState.usernameColumnIdx;
      var xlsEmail = null, xlsUsername = null;

      xlsState.activeUserEmails = activeAccountEmails;
      xlsState.activeUserUsernames = activeAccountUsernames;

      var seatsToBeFilled = 0;
      var hasErrors = false;
      var notAllowedTrainees = [];
      for (var i = 0, c = xlsState.rows.length; i < c; i++) {
        var row = xlsState.rows[i];
        if (row.$errors) {
          hasErrors = true;
          continue;
        }

        xlsEmail = row[emailIdx] ? row[emailIdx].toLowerCase().trim() : null;
        xlsUsername = row[usernameIdx] ? row[usernameIdx].toLowerCase().trim() : null;

        // if matched by username only, check if non-trainee record is attempted to be updated without email
        if (isTrainerWithoutEmail(xlsEmail, xlsUsername)) {
          setRowError(row, usernameIdx, 'Email is required for non-trainee');
          hasErrors = true;
          continue;
        }

        if (isUserNotInAllowedGroups(xlsEmail, xlsUsername)) {
          var errorMsg = 'Trainee already exists. \n Contact the administrator for access.';
          notAllowedTrainees.push(xlsEmail || xlsUsername);
          if (xlsEmail)
            setRowError(row, emailIdx, errorMsg);
          else
            setRowError(row, usernameIdx, errorMsg);
          hasErrors = true;
          continue;
        }

        if (!activeAccountEmails[xlsEmail] && !activeAccountUsernames[xlsUsername])
          seatsToBeFilled++;
        else if (!xlsState.existingUsersFound)
          xlsState.existingUsersFound = true;
      }

      if (mfConfig.useGroupRestrictions && notAllowedTrainees.length > 0) {
        actionLogResource.writeActionLog(_.map(notAllowedTrainees, function (msg) {
          return {
            action: mtypes.actionType.restrictedUserAdditionAttempted,
            metadata1: msg
          }
        }));
      }

      // we added 1 for the orginal admin to be added to the limit
      if (info.limit && seatsToBeFilled > info.limit - info.active.length + 1) {
        xlsState.generalErrors = 'The number of Trainees you are attempting to add will exceed your ' + info.limit +
        ' trainee plan. Please edit your file and reupload or upgrade your plan.';
        xlsState.hideGoodRowsOnError = false;
        xlsState.fatalError = true;
        return setView(screens.error);
      }

      xlsState.courses = filterSampleCourse(info.courses);
      xlsState.series = info.series;
      xlsState.groups = info.groups;

      _.each(xlsState.courses, function (item) {
        item.text = item.name;
        delete item.name;
        item.type = 'course';
      });
      _.each(xlsState.series, function (item) {
        item.text = item.name;
        delete item.name;
        item.type = 'series';
      });
      _.each(xlsState.groups, function (item) {
        item.text = item.name;
        delete item.name;
      });

      if (hasErrors) {
        if (seatsToBeFilled === 0 && !xlsState.existingUsersFound) {
          xlsState.generalErrors = "These records cannot be imported due to the errors found below.";
          xlsState.fatalError = true;
        } else {
          xlsState.generalErrors = "These records cannot be imported due to the errors found below. Continue to import the other records.";
        }
        xlsState.hideGoodRowsOnError = true;
        setView(screens.error);
      } else {
        setView(screens.confirm);
      }
    };

    function filterSampleCourse(courses) {
      if (!~accountFeatures.features.indexOf(mtypes.featureEntry.trainerHTMLHome)) {
        return _.filter(courses, function (item) {
          return item.id != mfConfig.sampleCourseId;
        });
      }

      return courses;
    }

    function isTrainerWithoutEmail(xlsEmail, xlsUsername) {
      return !xlsEmail &&
        activeAccountUsernames[xlsUsername] &&
        activeAccountUsernames[xlsUsername] !== mtypes.userRole.trainee;
    }

    function isUserNotInAllowedGroups(xlsEmail, xlsUsername) {
      return (xlsEmail && usersNotAllowedToUpdateByEmail[xlsEmail]) ||
        (xlsUsername && usersNotAllowedToUpdateByUsername[xlsUsername]);
    }

    function setRowError(row, colIdx, err) {
      if (!row.$errors)
        row.$errors = {};
      row.$errors[colIdx] = err;
    }

    var mapRowToUser = this.mapRowToUser = function (row) {
      var user = {};
      _.each(xlsState.userFields, function (userField) {
        if (userField.columnIdx === null) return;
        var fieldName = userField.id;

        if (row[userField.columnIdx])
          user[fieldName] = (row[userField.columnIdx] || '').trim();
      });
      return user;
    };

    var reset = $scope.reset = function () {
      if (importDialog) {
        importDialog.close();
        importDialog = null;
      }

      xlsState = $scope.xlsState = {};
      xlsState.state = states.start;

      var fields = xlsState.userFields = xlsConsts.getMfFields($scope.isUsernameEnabled);
      var customFields = accountCustomFields.getCustomFields();

      _.each(customFields, function (field) {
        fields.push({
          name: field.name,
          id: 'customField' + field.fieldIndex,
          columnIdx: null,
          customField: true,
          customFieldDisplayOrder: field.displayOrder,
          required: field.requiredState == mtypes.userCustomFieldRequiredState.required
        });
      });

      setTimeout(function () {
        //Browsers sometimes freak out if you change the url too quickly, so wrap in a timeout.
        setView(screens.upload);
        $location.replace();
        $scope.$apply();
      }, 50);
      
      if(hqSyncWarning){
        modalHelper.messageBox({
          title: hqTypes.Errors.SyncFailure.Title,
          message: hqTypes.Errors.SyncFailure.Message,
          buttons: [{label: 'OK'}]
        });
      }
    };

    reset();
  }

})();
